import {
  TAccount,
  TAccountWithRoleAssignments,
  TAccountWithRoles,
  TRoleAssignment,
  TRoleAssignmentWithAssociatedRole,
} from 'types/accounts'
import { TRole } from 'types/roles'

export const tranformAccountsToAccountsWithRoles = (
  accounts: TAccount[],
  roleAssigments: TRoleAssignment[],
  userRoles: TRole[]
) => {
  // Find all role assignmets assigned to current user, and then
  // apply them to user structure
  const accountsWithRoleAssignments = accounts?.reduce(
    (acc: TAccountWithRoleAssignments[], cur: TAccount) => {
      // Find assosiciated role assignments to user
      const assosiciatedRoleAssignments: TRoleAssignment[] = roleAssigments?.filter(
        (roleAssignment: TRoleAssignment) => roleAssignment?.userId === cur.id
      )

      return [...acc, { ...cur, roleAssignments: assosiciatedRoleAssignments ?? [] }]
    },
    []
  )

  // Find all Roles based on previous found role assignement, and then assign them to current user,
  // also assign particular role to roleAssignment
  const accountsWithRoleNameAndRoleAssignmentsExtendedWithAssignedRole =
    accountsWithRoleAssignments?.reduce(
      (acc: TAccountWithRoles[], cur: TAccountWithRoleAssignments) => {
        const assosiciatedUserRoleIds: string[] = cur?.roleAssignments?.map(
          ({ userRoleId }: { userRoleId: string }) => userRoleId
        )

        // Find all roles associated to user
        const associatedRoles: TRole[] = userRoles?.filter(({ uuid }: { uuid: string }) =>
          assosiciatedUserRoleIds.includes(uuid)
        )

        // Assign associated roles to user
        const roleAssigmentsWithParticularRole = cur?.roleAssignments?.reduce(
          (res: TRoleAssignmentWithAssociatedRole[], roleAssignment: TRoleAssignment) => {
            const associatedRole: TRole[] = userRoles?.filter(
              ({ uuid }: { uuid: string }) => uuid === roleAssignment.userRoleId
            )
            return [...res, { ...roleAssignment, userRoles: associatedRole }]
          },
          []
        )

        // Map roles to list only roles names
        const associatedRolesName: string[] = associatedRoles?.map(
          ({ name }: { name: string }) => name
        )

        return [
          ...acc,
          {
            ...cur,
            userRolesNames: associatedRolesName ?? [],
            roleAssignments: roleAssigmentsWithParticularRole,
          },
        ]
      },
      []
    )

  return accountsWithRoleNameAndRoleAssignmentsExtendedWithAssignedRole
}
